import { createApiClient, createServerClient } from "@membentry/shared-api";
import { useAuthStore } from "@/store/zustand/useAuthStore";
import { reportWebHttpError } from "@/observability/http-error";

const baseURL = process.env.NEXT_PUBLIC_BASE_URL || "http://localhost:5182/api";

export const axiosInstance = createApiClient({
  baseURL,
  timeout: 10000,
  getAccessToken: () => {
    return useAuthStore.getState().accessToken;
  },
  getRefreshToken: () => {
    return useAuthStore.getState().refreshToken;
  },
  onTokensRefreshed: (accessToken: string, refreshToken: string) => {
    useAuthStore.getState().setTokens(accessToken, refreshToken);
  },
  onAuthFailed: () => {
    useAuthStore.getState().clearAuthState();
  },
  onHttpError: reportWebHttpError,
});

export const axiosServer = createServerClient(baseURL, 10000);

export async function setServerAuthToken(token: string) {
  axiosServer.defaults.headers.common.Authorization = `Bearer ${token}`;
}
